import { createAction, props } from '@ngrx/store';
import { Layer, LayerList } from '../models/layer.model';
import { UIEffect, UIEffectItem } from '../models/ui-effects.model';
import { PresetData } from '../models/preset.model';
import { MoveLayerDirection } from '../models/properties.model';
import { EventEmitter } from 'stream';
import { Subject } from 'rxjs';

export const setSelectedLayer = createAction(
  '[Editor] Set Selected Layer',
  props<{ layerId?: string }>()
);

export const toggleShowEffects = createAction(
  '[Editor] Toggle show Layer',
  props<{ layerId: string }>()
);

export const deleteLayer = createAction(
  '[Editor] Delete Layer',
  props<{ layerId: string }>()
);

export const deleteEffect = createAction(
  '[Editor] Delete Effect',
  props<{ layerId: string, effectId: string }>()
);

export const selectEffect = createAction(
  '[Editor] Select Effect',
  props<{ effectId?: string }>()
);

export const cloneLayer = createAction(
  '[Editor] Clone Layer',
  props<{ layerId: string }>()
);

export const changeLayerOrder = createAction(
  '[Editor] Set Layer Order',
  props<{ id: string, index: number }>()
);

export const addNewLayer = createAction(
  '[Editor] Add New Layer',
  props<{ layer: Layer }>()
);

export const updateLayer = createAction(
  '[Editor] Update Layer',
  props<{ layerId: string, layer: Layer }>()
);

export const toggleLayerVisibility = createAction(
  '[Editor] Toggle Layer visibility',
  props<{ layerId: string }>()
);

export const setRender = createAction(
  '[Editor] Load Render',
  props<{
    layers: LayerList,
    layerOrder: string[],
    renderName: string,
    renderId: string
  }>()
)

export const updateRenderName = createAction(
  '[Editor] Update Render Name',
  props<{ name: string }>()
)

export const addEffectOrEffectLayer = createAction(
  '[Editor] Add effect or effect layer',
  props<{ layer: UIEffectItem}>()
)

export const addEffect = createAction(
  '[Editor] Add effect',
  props<{ layerId: string, effect: UIEffectItem}>()
)

export const saveRenderToFirebase = createAction(
  '[Editor] Attempt Save Render to Firebase',
)

export const saveGroupRenderToFirebase = createAction(
  '[Editor] Attempt Save Render to Firebase',
)

export const saveRenderToFirebaseSuccess = createAction(
  '[Editor] Save Render to Firebase Sucess',
)

export const saveZip = createAction(
  '[Editor] Save ZIP',
  props<{ filename: string, saveSuccess: () => void }>()
)

export const savePng = createAction(
  '[Editor] Save PNG',
  props<{ filename: string, saveSuccess: () => void }>()
)

export const resetEditorState = createAction(
  '[Editor] Reset Editor State'
)

export const createPersonalPreset = createAction(
  '[Editor] Create Personal Preset',
  props<{ name: string }>()
)

export const loadPreset = createAction(
  '[Editor] Load Preset',
  props<{ presetData: PresetData }>()
)

export const defaultEditorState = createAction(
  '[Editor] Default Editor State',
)

export const moveLayer = createAction(
  '[Editor] Move Layer',
  props<{ direction: MoveLayerDirection, layerId: string}>()
)

export const moveEffect = createAction(
  '[Editor] Move Effect',
  props<{ direction: MoveLayerDirection, effectId: string, layerId: string}>()
)
